import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DetailComponent } from '@app/common/templates/detail/detail.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
	templateUrl: '../../../../common/templates/detail/detail.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/detail/style.scss'],
	providers: [MessageService, ConfirmationService]
})
export class TblFahrzeugAkteKomponenteLinkDetailComponent extends DetailComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, messageService, router, translate);

		this.apiUrl = 'TblFahrzeugAkteKomponenteLink';
		this.name = 'MENU.FAHRZEUGAKTE_KOMPONENTE_LINK';
		this.url = '/' + PATH.FAHRZEUGAKTE_KOMPONENTE_LINK;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'object', key: 'FREMD_fahrzeug_ankey', required: false, width: 400, url: '/' + PATH.FAHRZEUG, id: 'FREMD_fahrzeug_id' },
				{ type: 'object', key: 'FREMD_fahrzeug_kennzeichen', required: false, width: 400, url: '/' + PATH.FAHRZEUG, id: 'FREMD_fahrzeug_id' },
				{ type: 'object', key: 'FREMD_fahrzeug_bezeichnung', required: false, width: 400, url: '/' + PATH.FAHRZEUG, id: 'FREMD_fahrzeug_id' },
				{ type: 'text', key: 'FREMD_fahrzeug_logbox_serial', required: false, width: 400 },
				{ type: 'object', key: 'FREMD_komponente_ankey', required: false, width: 400, url: '/' + PATH.KOMPONENTE, id: 'komponente_id' },
				{ type: 'object', key: 'FREMD_komponente_bezeichnung', required: false, width: 400, url: '/' + PATH.KOMPONENTE, id: 'komponente_id' },
				{ type: 'text', key: 'FREMD_komponente_bemerkungen', required: false, width: 400 },
				{ type: 'object', key: 'FREMD_komponente_typ_ankey', required: false, width: 400, url: '/' + PATH.KOMPONENTE_TYP, id: 'FREMD_komponente_typ_id' },
				{ type: 'object', key: 'FREMD_komponente_typ_bezeichnung', required: false, width: 400, url: '/' + PATH.KOMPONENTE_TYP, id: 'FREMD_komponente_typ_id' },
				{ type: 'text', key: 'zugeordnet_von_string', required: false, width: 400 },
				{ type: 'text', key: 'zugeordnet_bis_string', required: false, width: 400 },
				{ type: 'text', key: 'bemerkungen', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.DETAIL', routerLink: [this.url + '/' + PATH.DETAIL + '/' + this.id] }
		]);
	}
}
